import { createDeepEqualSelector } from './';
import { RootState } from '../store';

export const representativesSelector = (state: RootState) =>
  state.representatives;

export const representativesListSelector = createDeepEqualSelector(
  representativesSelector,
  (state) => state.representativesList ?? [],
);

export const representativesStatus = createDeepEqualSelector(
  representativesSelector,
  (state) => state.status,
);

export const representativesProductId = createDeepEqualSelector(
  representativesSelector,
  (state) => state.productId,
);
